import React, { Component } from 'react';
import '../App.css';

class SuccessPage extends Component {

  render() {
    
    return (
      <section id="success-page">
        <h2>Thank you! A Fintwist representative will reach out to you shortly.</h2>
      </section>
    );
  }
}

export default SuccessPage;
